import computeClassName from '../../../../../../utils/computeClassName';


const constants = Object.freeze({
  CLASSNAME_BASE: 'text-cc-body-medium font-light',
  CLASSNAME_IS_INPUT_DISABLED: {
    true: 'text-cc-muted-contrast',
    false: 'text-cc-primary-contrast'
  }
});

function getComputedClassName(propsClassName, isInputDisabled) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_IS_INPUT_DISABLED[isInputDisabled]}`);
}

export default function CCFormInputCaption({captionText, isInputDisabled, className}) {
  const computedClassName = getComputedClassName(className, isInputDisabled);
  return <span className={computedClassName}>{captionText}</span>;
}
